// src/routes/onboardingRoutes.js

import OnboardingConfiguration from "../app/modules/Recrutement/onboarding/OnboardingConfiguration";
import ParcoursManagement from "../app/modules/Recrutement/onboarding/ParcoursManagement";
import ModuleCleManagement
    from "../app/modules/Formation/ResponsableFormation/RessourcesJs/moduleCle/ModuleCleManagement";
import OnboardingSponsorship from "../app/modules/Recrutement/onboarding/OnboardingSponsorship";
import OnboardingRecrue from "../app/modules/Recrutement/onboarding/OnboardingRecrue";
import QuizManagement from "../app/modules/QuizAndQuestions/QuizManagement";
import QuestionManagement from "../app/modules/QuizAndQuestions/QuestionManagement";

export const OnboardingRoutes = [
    { path: "/recrutement/onboarding/configuration", element: <OnboardingConfiguration /> },
    { path: "/recrutement/onboarding/parcours", element: <ParcoursManagement /> },
    { path: "/recrutement/onboarding/modules", element: <ModuleCleManagement moduleContext="ONBOARDING" /> },
    { path: "/recrutement/onboarding/sponsorship", element: <OnboardingSponsorship /> },
    { path: "/recrutement/onboarding/config", element: <OnboardingConfiguration /> },
    { path: "/recrutement/onboarding/quizzes", element: <QuizManagement moduleContext="ONBOARDING" /> },
    { path: "/recrutement/onboarding/quizzes/:quizId/questions", element: <QuestionManagement /> },
    { path: "/collaborateur/onboarding", element: <OnboardingRecrue /> },
];
